export default {
    SET_FACULTY_UNIVERSITY_TYPES (state, facultyUniversityTypes) {
      state.facultyUniversityTypes = facultyUniversityTypes
    },
    SET_BRANCHE_TYPES (state, brancheTypes) {
      state.brancheTypes = brancheTypes
    },
    SET_STARTUPPHASE_TYPES (state, startupPhaseTypes) {
      state.startupPhaseTypes = startupPhaseTypes
    },
    SET_COUNTRY_TYPES (state, countryTypes) {
      state.countryTypes = countryTypes
    },
    SET_CASEQUALITY_TYPES (state, casequalityTypes) {
      state.casequalityTypes = casequalityTypes
    },
    SET_AFFIRMATION_TYPES (state, affirmationTypes) {
      state.affirmationTypes = affirmationTypes
    },
    SET_UNIVERSITY_TYPES (state, universityTypes) {
      state.universityTypes = universityTypes
    },
    SET_RECHTSFORM_TYPES (state, rechtsformTypes) {
      state.rechtsformTypes = rechtsformTypes
    },
    SET_LANGUAGES_TYPES (state, languagesTypes) {
      state.languagesTypes = languagesTypes
    },
    SET_EDUCATION_TYPES (state, educationTypes) {
      state.educationTypes = educationTypes
    },
    SET_CANTON_TYPES (state, cantonTypes) {
      state.cantonTypes = cantonTypes
    },
    SET_SALUTATION_TYPES (state, salutationTypes) {
      state.salutationTypes = salutationTypes
    },
    SET_PRIOVLAB_TYPES (state, priovlabTypes) {
      state.priovlabTypes = priovlabTypes
    },
    SET_PRIOVLABXMAS_TYPES (state, priovlabxmasTypes) {
      state.priovlabxmasTypes = priovlabxmasTypes
    },
    SET_PROFILCATEGORY_TYPES (state, profilcategoryTypes) {
      state.profilcategoryTypes = profilcategoryTypes
    },
    SET_VKCASESTATUS_TYPES (state, vkCaseStatusTypes) {
      state.vkCaseStatusTypes = vkCaseStatusTypes
    },
    SET_INVESTMENT_TYPES (state, investmentTypes) {
      state.investmentTypes = investmentTypes
    },
    SET_INVESTMENT_STAGES (state, investmentStages) {
      state.investmentStages = investmentStages
    },
    SET_PROFILE_STATUS (state, profileStatus) {
      state.profileStatus = profileStatus
    },
    SET_TYPE_OF_ORGANIZATION (state, typeofOrganization) {
      state.typeofOrganization = typeofOrganization
    },
    SET_ROLES (state, roles) {
      state.roles = roles
    },
    SET_VEKMIS_TECHNOLOGY (state, vekmisTechnology) {
      state.vekmisTechnology = vekmisTechnology
    },
    SET_INTERESTS (state, addressInterests) {
      state.addressInterests = addressInterests
    },
    SET_AWARDS (state, awards) {
      state.awards = awards
    },
    SET_SECTORS (state, sectors) {
      state.sectors = sectors
    },
    SET_REPORTING_GROUPS (state, reportingGroups) {
      state.reportingGroups = reportingGroups
    },
    SET_EVENT_SIGNUP_FUNKTION (state, eventSignupFunctions) {
      state.eventSignupFunctions = eventSignupFunctions
    },
    SET_EVENT_STARTUP_STAGE_IS_2025 (state, eventStartupStages) {
      state.eventStartupStages = eventStartupStages
    },
    SET_EVENT_STARTUP_SECTORS_IS_2025 (state, eventStartupSectors) {
      state.eventStartupSectors = eventStartupSectors
    },
    SET_EVENT_INDUSTRY_EXPERIENCE_IS_2025 (state, eventIndustryExperiences) {
      state.eventIndustryExperiences = eventIndustryExperiences
    },
    SET_STARTUP_RELATIONSHIP_UNI_IS_2025 (state, eventRelationshipUnis) {
      state.eventRelationshipUnis = eventRelationshipUnis
    },
    SET_EVENT_EMPLOYMENTSTATUS_IS_2025 (state, eventEmploymentStatus) {
      state.eventEmploymentStatus = eventEmploymentStatus
    }
  }
